// FileDrop component is copy of: https://www.npmjs.com/package/ngx-file-drop

import { Component, ViewEncapsulation, Output, EventEmitter, NgZone, OnDestroy } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { UploadEvent, UploadFile, FileSystemEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from '../../models/imports/generic';

@Component({
  selector: 'app-file-drop',
  templateUrl: './file-drop.component.html',
  styleUrls: ['./file-drop.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class FileDropComponent implements OnDestroy {
  @Output() public fileDrop: EventEmitter<UploadEvent> = new EventEmitter<UploadEvent>();
  @Output() public fileOver: EventEmitter<any> = new EventEmitter<any>();
  @Output() public fileLeave: EventEmitter<any> = new EventEmitter<any>();

  stack = [];
  files: UploadFile[] = [];
  subscription: Subscription;
  dragoverflag = false;

  constructor(private zone: NgZone) { }

  public onDragOver(event: Event): void {
    if (!this.dragoverflag) {
      this.dragoverflag = true;
      this.fileOver.emit(event);
    }
    this.preventAndStop(event);
  }

  public onDragLeave(event: Event): void {
    if (this.dragoverflag) {
      this.dragoverflag = false;
      this.fileLeave.emit(event);
    }
    this.preventAndStop(event);
  }

  dropFiles(event: any) {
    this.dragoverflag = false;
    event.dataTransfer.dropEffect = 'copy';
    let length;
    if (event.dataTransfer.items) {
      length = event.dataTransfer.items.length;
    } else {
      length = event.dataTransfer.files.length;
    }

    for (let i = 0; i < length; i++) {
      let entry: FileSystemEntry;
      if (event.dataTransfer.items) {
        if (event.dataTransfer.items[i].webkitGetAsEntry) {
          entry = event.dataTransfer.items[i].webkitGetAsEntry();
        }
      } else {
        if (event.dataTransfer.files[i].webkitGetAsEntry) {
          entry = event.dataTransfer.files[i].webkitGetAsEntry();
        }
      }
      if (!entry) {
        const file: File = event.dataTransfer.files[i];
        if (file) {
          const fakeFileEntry: FileSystemFileEntry = {
            name: file.name,
            isDirectory: false,
            isFile: true,
            file: (callback: (filea: File) => void): void => {
              callback(file);
            }
          };
          const toUpload: UploadFile = new UploadFile(fakeFileEntry.name, fakeFileEntry);
          this.addToQueue(toUpload);
        }
      } else {
        if (entry.isFile) {
          const toUpload: UploadFile = new UploadFile(entry.name, entry);
          this.addToQueue(toUpload);
        } else if (entry.isDirectory) {
          this.traverseFileTree(entry, entry.name);
        }
      }
    }

    this.preventAndStop(event);

    this.subscription = timer(200, 200).subscribe(t => {
      if (this.stack.length === 0) {
        this.fileDrop.emit(new UploadEvent(this.files));
        this.files = [];
        this.subscription.unsubscribe();
      }
    });
  }

  private traverseFileTree(item: FileSystemEntry, path: string) {

    if (item.isFile) {
      const toUpload: UploadFile = new UploadFile(path, item);
      this.files.push(toUpload);
      this.zone.run(() => {
        this.popToStack();
      });
    } else {
      this.pushToStack(path);
      path = path + '/';
      const dirReader = (item as FileSystemDirectoryEntry).createReader();
      let entries = [];
      const thisObj = this;

      const readEntries = function () {
        dirReader.readEntries(function (res) {
          if (!res.length) {
            // add empty folders
            if (entries.length === 0) {
              const toUpload: UploadFile = new UploadFile(path, item);
              thisObj.zone.run(() => {
                thisObj.addToQueue(toUpload);
              });
            } else {
              for (let i = 0; i < entries.length; i++) {
                thisObj.zone.run(() => {
                  thisObj.traverseFileTree(entries[i], path + entries[i].name);
                });
              }
            }
            thisObj.zone.run(() => {
              thisObj.popToStack();
            });
          } else {
            // continue with the reading
            entries = entries.concat(res);
            readEntries();
          }
        });
      };

      readEntries();
    }
  }

  private addToQueue(item: UploadFile) {
    this.files.push(item);
  }

  pushToStack(str) {
    this.stack.push(str);
  }

  popToStack() {
    const value = this.stack.pop();
  }

  private clearQueue() {
    this.files = [];
  }

  private preventAndStop(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
